import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { FormHelperText, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { addWhatsappTemplate, updateWhatsappTemplate } from "network/service";
import Autocomplete from "@mui/material/Autocomplete";

export default function AddTemplate(props) {
    const [newField, setNewField] = useState({ name: "", variables: "", content: '' });
    const [errors, setErrors] = useState({});
    const { showNotification } = useNotification();
    const [roles, setRoles] = useState([]);
    const [selRole, setSelRole] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (props.details) {
            setNewField({ name: props.details.name, variables: props.details.variables.toString(), content: props.details.content });
        }
    }, [props.details])

    const validate = () => {
        let isValid = true;
        let newErrors = {};

        if (newField.name.trim() === "") {
            newErrors = { ...newErrors, name: "Name is required" };
            isValid = false;
        }
        if (newField.variables.trim() === "") {
            newErrors = { ...newErrors, variables: "Variable is required" };
            isValid = false;
        }
        if (newField.content.trim() === "") {
            newErrors = { ...newErrors, content: "Content is required" };
            isValid = false;
        }
        setErrors(newErrors);
        return isValid;
    }

    const submit = async () => {
        try {
            const isValid = validate();

            if (isValid) {
                setLoading(true);
                if (props.details && props.details._id) {
                    console.log("Updating Branch with id:", props.details._id);
                    await updateWhatsappTemplate(props.details._id, { name: newField.name, variables: parseInt(newField.variables), content: newField.content });
                    showNotification("success", "Success", "Updated the Whatsapp Template successfully");
                    props.handlesuccess();
                } else {
                    console.log("Adding new Branch");
                    await addWhatsappTemplate({ name: newField.name, variables: parseInt(newField.variables), content: newField.content });
                    showNotification("success", "Success", "Added the Whatsapp Template successfully");
                    props.handlesuccess();
                }
                setLoading(false);
                props.handleclose();
            }
        } catch (err) {
            console.error("Error Country Details:", err);
            setLoading(false);
            showNotification("error", "Error", "Failed to add Template.");
        }
    };

    useEffect(() => {
        console.log("props.details:", props.details);
        if (props.details) {
            console.log("Setting newField with props.details:", props.details);

        }
    }, [props.details]);



    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >
            <div>
                <DialogTitle>{props.details ? 'Edit Template' : 'Add Template'}</DialogTitle>
            </div>
            <DialogContent sx={{ minWidth: 500 }}>
                <Grid container direction="column" spacing={2}>
                    <Grid item >
                        <MDInput
                            label="Name"
                            value={newField.name}
                            fullWidth
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    name: e.target.value
                                });
                            }}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.name}</FormHelperText>}
                        // helperText={
                        //     <FormHelperText sx={{ color: '#FF0000', fontWeight: 800, margin: 0 }}>
                        //         {errors.name && "Customer Name is required"}
                        //     </FormHelperText>
                        // }
                        />

                    </Grid>
                    <Grid item>
                        <MDInput
                            fullWidth
                            label="Variables"
                            value={newField.variables}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.variables}</FormHelperText>}
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    variables: e.target.value
                                });
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <MDInput
                            fullWidth
                            label="Code"
                            multiline
                            rows={4}
                            value={newField.content}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.content}</FormHelperText>}
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    content: e.target.value
                                });
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <MDButton variant="gradient" color="error" onClick={props.handleclose}>
                    <Icon>close</Icon>&nbsp;
                    Cancel
                </MDButton>
                <MDButton variant="gradient" color="success" onClick={submit}>
                    <Icon>save</Icon>&nbsp;
                    Save
                </MDButton>

            </DialogActions>
        </Dialog>
    )
}
